<app-entity-auto-complete-host />
<div class="relative flex h-full w-full">
  @if (planPanel.planInView() && planPanel.open()) {
    <app-plan-panel />
  }
  <div class="h-full min-w-0 flex-1">
    <router-outlet />
  </div>
  @if (assistant.toggleVisible() && assistant.panelOpen()) {
    <app-assistant-panel />
  }
  <app-assistant-file-preview />
  <!-- The reference outlet follows the finding card so the popover opened from inside the card paints above it. -->
  <app-plan-finding-card-outlet />
  <app-reference-popup-outlet scope="shell" [canAddToFilter]="false" />
  <app-kpi-detail-card-outlet />
</div>
